import { REGION_MODE, ENV_MODE } from './config';

interface BaseInfo {
  country: string;
  lang: string;
  requestLang: string;
  requestCountry: string;
  env: string;
}

const defaultConfig: any = {
  // 海外环境
  us: {
    country: 'us', // 国家
    lang: 'en', // 语言
    requestCountry: 'us', // 国家
    requestLang: 'en', // 语言
    env: ENV_MODE
  },
  // 国内环境
  cn: {
    country: 'cn',
    lang: 'zh',
    requestCountry: 'cn', // 国家
    requestLang: 'zh', // 语言
    env: ENV_MODE
  }
};

export let environmentData: BaseInfo = defaultConfig[REGION_MODE];
